import FormControl from "@mui/material/FormControl/FormControl";
import InputLabel from "@mui/material/InputLabel/InputLabel"
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Select from "@mui/material/Select/Select";
import { useState } from "react";

interface ISelectInput {
    label: string;
    id: string;
    options: Array<{value: any;label: any;}>;
    handleClick: (value: string) => void;
}
     


export const SelectMonth = (prop: ISelectInput) => {
    const [value, setValue] = useState('')

    const id = prop.id
    const label = prop.label
    const handleChange = (event: any) => {
        setValue(event.target.value)
        prop.handleClick(event.target.value);
      };
    return (
        <FormControl color='secondary' variant="standard" fullWidth size='small'>
            <InputLabel id={id} sx={{pb: 2}}>{label}</InputLabel>
            <Select
                id={id}
                value={value}
                label={label}
                onChange={handleChange}
                size='small'
            >
                {prop.options.map(option => (
                    <MenuItem value={option.value}>{option.label}</MenuItem>
                ))}
                
            </Select>
        </FormControl>
    )
}